export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL ?? '/api';
export const PASSWORD_LOGIN_DISABLED = process.env.REACT_APP_PASSWORD_LOGIN_DISABLED === 'true';
export const ADZ_REDIRECT_URI = process.env.REACT_APP_ADZ_REDIRECT_URI ?? 'http://localhost:5173/';
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID ?? '';
export const COINIS_LOGO_DARK = 'https://coinis.com/images/logo-dark.svg';
export const GTM_ID = process.env.REACT_APP_GTM_ID ?? '';
